module.exports = __webpack_public_path__ + "static/media/car.de2bf2fd.png";